import axios from "axios";
import type { AxiosInstance } from "axios";
import { getCookie } from "shared/auth/utils/cookieUtils";
import { getApiOrigin } from "./apiOrigin";

export const apiClient: AxiosInstance = axios.create({
  baseURL: getApiOrigin(),
});

apiClient.interceptors.request.use((config) => {
  const token = getCookie("userToken");
  if (token && !config.headers?.Authorization) {
    config.headers = {
      ...(config.headers as unknown as Record<string, unknown>),
      Authorization: `Bearer ${token}`,
    } as any;
  }
  return config;
});
